// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slide_slide__2MRJ1","active":"Slide_active__3hKY6","sliderImg":"Slide_sliderImg__1dk55","titleContainer":"Slide_titleContainer__3oCjc"};